import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import countryInfo from '../../../assets/countries.json';
import * as api from '../../../api';

const StaffCreate = ({
  isOpen,
  toggle,
  reload,
}) => {
  const { t } = useTranslation();
  const countryInfoList = Object.values(countryInfo);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ countryNumber, setCountryNumber ] = useState('82');
  const [ isOpenStaffCreateSuccessModal, setIsOpenStaffCreateSuccessModal ] = useState(false);
  const [ isOpenStaffCreateFailModal, setIsOpenStaffCreateFailModal ] = useState(false);
  const [ messageStaffCreateFail, setMessageStaffCreateFail ] = useState('');
  const [ staffCreateItem, setStaffCreateItem ] = useState({
    name: '',
    phoneNumber: '',
    role: '',
  });
  const roleItems = [
    { key: t('data.staff_role.master'), value: 'master' },
    { key: t('data.staff_role.manager'), value: 'manager' },
    { key: t('data.staff_role.housekeeping'), value: 'housekeeping' },
    { key: t('data.staff_role.manager_mobilekey'), value: 'manager_mobilekey' },
    { key: t('data.staff_role.doorlock_setting'), value: 'doorlock_setting' },
  ];

  const createStaff = async () => {
    try {
      setIsLoading(true);
      const reqNum = countryNumber + Number.parseInt(staffCreateItem.phoneNumber);
      await api.createStaff({...staffCreateItem, phoneNumber:reqNum});
      toggle();
      setIsOpenStaffCreateSuccessModal(true);
      setTimeout(() => {
        setIsOpenStaffCreateSuccessModal(false);
        reload();
      }, 1500);
    } catch (error) {
      if (!error.response) setMessageStaffCreateFail(error.message);
      else setMessageStaffCreateFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenStaffCreateFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const init = () => {
      setStaffCreateItem({
        name: '',
        phoneNumber: '',
        role: '',
      });
      setCountryNumber('82');
    };
    init();
  }, [isOpen]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
        size='md'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3' style={{margin:0, padding:0, backgroundColor:'#282C34'}}>
          <div className='form-card'>
            <h4 className='form-card-title'>{t('content_title.staff_add')}</h4>
            <div className='inline-flex'>
              <div className='w-100'>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.staff_name')}</b><span className='required'>*</span>
                  </p>
                  <input
                    className='card-text-input'
                    placeholder={t('placeholder.staff_name')}
                    onChange={e => setStaffCreateItem({...staffCreateItem, name:e.target.value})}
                  />
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.phone_number')}</b><span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    value={countryNumber}
                    onChange={e => setCountryNumber(e.target.value)}
                  >
                    {countryInfoList.map((country, index) => (
                      <option key={`country-index-${index}`} value={country.phone}>{`${country.name} ( +${country.phone} )`}</option>
                    ))}
                  </select>
                  <p></p>
                  <input
                    className='card-text-input'
                    placeholder={t('placeholder.phone_number')}
                    maxLength='11'
                    onChange={e => setStaffCreateItem({...staffCreateItem, phoneNumber:e.target.value})}
                  />
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.role')}</b><span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    onChange={e => setStaffCreateItem({...staffCreateItem, role:e.target.value})}
                  >
                    <option value='' hidden>{t('placeholder.role')}</option>
                    {roleItems.map((role, index) => (
                      <option key={index} value={role.value}>{role.key}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className='card-foot'>
              <div className='form-item-cancel'>
                <button className='btn-item-cancel' onClick={() => toggle()}>
                  <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>{t('button.cancel')}</span>
                </button>
              </div>
              <div className='form-item-add center'>
                <button className='btn-item-add' onClick={createStaff}>
                  <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>{t('button.save')}</span>
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenStaffCreateSuccessModal}
        toggle={() => setIsOpenStaffCreateSuccessModal(!isOpenStaffCreateSuccessModal)}
        message={t('success_message.add_staff')}
      />
      <ResponseFailModal
        isOpen={isOpenStaffCreateFailModal}
        toggle={() => setIsOpenStaffCreateFailModal(!isOpenStaffCreateFailModal)}
        message={messageStaffCreateFail || t('error_message.add_staff')}
      />
    </Fragment>
  );
};

export default StaffCreate;